import { COLOURS, FONT_WEIGHTS, FONT_SIZES } from '../../../common/styles/vars';

const DROPDOWN_BORDER_SIZE = 2;

export default (({ disabled, menuWidth, overrides = {} }) => ({
  dummyInput: (provided) => ({
    ...provided,
    height: 0
  }),
  singleValue: (provided) => ({
    ...provided,
    fontSize: 12
  }),
  multiValue: (provided) => ({
    ...provided,
    alignItems: 'center',
    backgroundColor: COLOURS.cyan.jungleGreen.monkey,
    color: 'red',
    borderRadius: '3px',
    display: 'inline-flex',
    justifyContent: 'center',
    height: '25px',
    padding: '1px 8px 0 8px',
    textTransform: 'uppercase'
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: COLOURS.grey.athens.parthenon,
    textTransform: 'none',
    paddingLeft: 0,
    fontSize: FONT_SIZES.small,
    lineHeight: '24px'
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    backgroundColor: COLOURS.cyan.jungleGreen.monkey,
    color: COLOURS.grey.athens.parthenon,
    padding: 0,
    margin: 'auto',

    ':hover': {
      backgroundColor: COLOURS.cyan.turquoise,
      color: COLOURS.grey.athens.parthenon
    },

    '& > svg': {
      width: '18px',
      height: '18px'
    }
  }),
  indicatorSeparator: (provided) => ({
    ...provided,
    display: 'none'
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    minHeight: 40 - DROPDOWN_BORDER_SIZE,
    padding: '0px 16px'
  }),
  control: (provided) => ({
    ...provided,
    background: disabled ? COLOURS.grey.athens.parthenon : 'transparent',
    boxShadow: 'none',
    borderColor: COLOURS.grey.regent50,
    minHeight: 40,
    // paddingLeft: 7,
    '&:hover': {
      borderColor: COLOURS.grey.regent50,
      background: COLOURS.grey.athens.parthenon
    },
    cursor: 'pointer',
    border: 'none',
    borderRadius: 4
  }),
  menu: (provided) => ({
    ...provided,
    boxShadow: '0 6px 20px 0 rgba(13, 51, 32, 0.1)',
    borderRadius: 8,
    ...(menuWidth ? { width: menuWidth, minWidth: menuWidth } : {})
  }),
  menuList: (provided) => ({
    ...provided,
    paddingTop: '5px',
    paddingBottom: '5px'
  }),
  menuPortal: (provided) => ({
    ...provided,
    zIndex: 102
  }),
  placeholder: (provided) => ({
    ...provided,
    margin: 0,
    color: disabled ? COLOURS.grey.nevada : COLOURS.grey.nightRider,
    fontSize: FONT_SIZES.default,
    fontWeight: FONT_WEIGHTS.medium,
    lineHeight: '22px',
    letterSpacing: '0.3px'
  }),
  option: (provided, { isSelected }) => ({
    ...provided,
    backgroundColor: 'transparent',
    cursor: 'pointer',
    padding: '16px 12px',
    fontWeight: isSelected ? 'bold' : 'initial',
    color: COLOURS.mono.black,
    '&:hover': {
      backgroundColor: COLOURS.grey.catSkillWhite
    }
  }),
  valueContainer: (provided) => ({
    ...provided,
    overflow: 'hidden',
    ' > input': {
      height: 0
    },
    paddingTop: 0,
    paddingBottom: 0,
    textOverflow: 'ellipsis'
  }),
  input: (provided) => ({
    ...provided,
    position: 'absolute',
    margin: 'auto',
    width: '100%',

    ' > div': {
      width: '100%',

      ' > input': {
        maxWidth: 'calc(100% - 20px)'
      }
    }
  }),
  groupHeading: (provided) => ({
    ...provided,
    margin: '16px 16px 16px 4px',
    color: '#000000',
    fontSize: '16px',
    textTransform: 'unset'
  }),
  ...overrides
}));